import React, { FC, useState } from 'react';
import { Icon } from '@/components/atomic/Icon';
import Timer from '@/components/Timer';
import Toast from '@/components/Toast';

export interface IResentOtpProps {
  timeout?: number;
  onResend: () => void;
  title?: string;
  buttonTitle?: string;
}

const ResentOTP: FC<IResentOtpProps> = ({
  timeout = 90,
  onResend,
  title = 'کد تایید ارسال نشد؟',
  buttonTitle = 'ارسال مجدد کد تایید',
}) => {
  const [canResend, setCanResend] = useState<boolean>(false);

  return (
    <div>
      <div className="flex text-xs font-regular text-blue ltr">
        <div className="ml-3 mt-1">
          <Timer
            timeout={canResend ? 0 : timeout}
            onEnd={() => setCanResend(true)}
          />
        </div>
      </div>

      <div className="mb-[70px] mt-4 flex items-center justify-between">
        <div className="flex items-center justify-center gap-[4px] text-gray-90 ">
          <Icon icon="info_outline" size={16} />
          <span className="text-xs !font-medium md:text-xxs">{title}</span>
        </div>

        <div
          className={`cursor-pointer text-xs !font-medium md:text-xxs ${
            canResend ? 'text-blue-a40 ' : 'pointer-events-none text-gray-80'
          }`}
          onClick={async () => {
            try {
              await onResend();
              setCanResend(false);
            } catch (e: any) {
              Toast.open({
                variant: 'error',
                children: `${e?.message || e}`,
              });
            }
          }}
        >
          {buttonTitle} <Icon icon="chevron_left" />
        </div>
      </div>
    </div>
  );
};

export default ResentOTP;
